import { Injectable } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { FeeQueryParamKey, PartnerQueryParamKey, UrlBuilder, UrlQueryParamService } from '@ddt-web/url';

@Injectable({
	providedIn: 'root'
})
export class ModelsBrowseLinkActionsService {

	@InjectQueryParam(FeeQueryParamKey.CUSTOM_FEE) private readonly customFee: string;
	@InjectQueryParam(PartnerQueryParamKey.TEST_PARTNER_FIRM) private readonly testPartnerFirm: string;

	constructor(
		private hrefService: HrefResolverService,
		private urlQueryParamService: UrlQueryParamService
	) {
	}

	public redirectOnLinkAction(pageName: string, path: string, portfolios: string, mode?: string): void {
		if (pageName && path && portfolios) {
			const portfolioIds = portfolios.split(',');
			if (portfolioIds?.length > 1) {
				const portfolioList = this.urlQueryParamService.transformObjectToParams({ ...[portfolioIds] });
				portfolios = portfolioList?.[0];
			}
			const page = this.hrefService.getResolvedUrl(pageName);
			const url = UrlBuilder.construct().setPath(page + '/' + path).addParam('portfolios', portfolios);
			if (mode) {
				url.addParam('mode', mode);
			}
			if (this.customFee) {
				url.addParam(FeeQueryParamKey.CUSTOM_FEE, this.customFee);
			} else {
				url.addParam(FeeQueryParamKey.EXCLUDE_FEE, 'true');
			}
			if (this.testPartnerFirm) {
				url.addParam(PartnerQueryParamKey.TEST_PARTNER_FIRM, this.testPartnerFirm);
			}
			window.open(url.build().toString(), '_blank');
		}
	}
}
